import ProjectSection from '../../Sections/ProjectsSection/ProjectSection';
import UxSection from '../../Sections/UxSection/UxSection';
import './ProjectsPage.css';
import React from 'react';

export default function ProjectsPage(){
    return(
        <>
            <UxSection/>
            <ProjectSection/>
        </>
    );
}